module.exports = __webpack_public_path__ + "img/datamatrix_150ppi.c2926f5f.png";